// © Microsoft Corporation. All rights reserved.

export enum Market {
    BR = "pt-br",
    ENCA = "en-ca",
    FRCA = "fr-ca",
    FRFR = "fr-fr",
    IN = "en-in",
    ENUS = "en-us",
    ZHCN = "zh-cn"
}